import React, { useState } from "react";

import { Grid } from "@material-ui/core";

import {
  Create,
  email,
  FormDataConsumer,
  maxLength,
  minLength,
  regex,
  required,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { BackButton } from "../../../../components/common/BackButton";
import { ForceTitle } from "../../../../components/common/ForceTitle";
import { HelpButton } from "../../../../components/common/HelpButton";

import { REGEX_PHONE } from "../../../../utils/constants";
import { parsePhoneDigits } from "../../../../utils/carrierUserUtils";

import { CarrierUserCreateHelp } from "./CarrierUserHelp";
import { ValidateCreateButton } from "./ValidateCreateButton";
import { CarrierDropDown } from "./CarrierDropDown";

const validateRequired = required();
const validateEmail = [required(), email()];
// Optional, as on the user's edit form and on the carrier's own. Everyone
// invited from here joins as dispatch, and a dispatcher is reached by email:
// only a driver needs a number, because the gate finds a driver by (phone,
// lastName) on the exact-match carrierUserByPhone index. Requiring one here
// left an invite unsendable until somebody invented a number for it — the
// carrier the invite is for may have none on file itself.
const validatePhone = [
  regex(REGEX_PHONE, "Must be valid Phone No."),
  minLength(10),
  maxLength(20),
];

const UserCreateForm = ({ setSelectedCarrier, ...props }) => {
  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => (
        <>
          <Grid container spacing={5}>
            <Grid item xs={12} md={8}>
              <Grid container direction="column" spacing={1}>
                <Grid container direction="row" spacing={2}>
                  <Grid item xs={12} lg={6}>
                    <CarrierDropDown
                      source="carrierId"
                      label="Carrier"
                      allowEmpty={true}
                      validate={validateRequired}
                      enableCreate
                      onCarrierChange={(carrier) => {
                        setSelectedCarrier(carrier);
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container direction="row" spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextInput
                      source="firstName"
                      label="First Name"
                      variant="outlined"
                      validate={validateRequired}
                      fullWidth
                      helperText={false}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextInput
                      source="lastName"
                      label="Last Name"
                      variant="outlined"
                      validate={validateRequired}
                      fullWidth
                      helperText={false}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextInput
                      source="email"
                      type="email"
                      variant="outlined"
                      fullWidth
                      parse={(v) => (v !== "" ? v.toLowerCase() : undefined)}
                      validate={validateEmail}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextInput
                      source="phone"
                      type="tel"
                      variant="outlined"
                      fullWidth
                      parse={parsePhoneDigits}
                      validate={validatePhone}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextInput
                      source="notes"
                      label="Notes"
                      variant="outlined"
                      multiline
                      rows={3}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </FormDataConsumer>
  );
};

const UserCreateActions = (props) => (
  <TopToolbar>
    <HelpButton>
      <CarrierUserCreateHelp {...props} />
    </HelpButton>
    <BackButton {...props} />
  </TopToolbar>
);

const UserCreateToolbar = (props) => (
  <Toolbar {...props}>
    <ValidateCreateButton carrier={props.carrier} />
  </Toolbar>
);

export const CarrierUserCreate = (props) => {
  const [selectedCarrier, setSelectedCarrier] = useState(null);

  return (
    <Create
      {...props}
      title={<ForceTitle title="New User" />}
      actions={<UserCreateActions />}
    >
      <SimpleForm
        variant="outlined"
        submitOnEnter={false}
        toolbar={<UserCreateToolbar carrier={selectedCarrier} />}
      >
        <UserCreateForm {...props} setSelectedCarrier={setSelectedCarrier} />
      </SimpleForm>
    </Create>
  );
};
